import { __decorate, __metadata, __assign, __values } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

var AngularFileUploaderService = /** @class */ (function () {
    function AngularFileUploaderService() {
    }
    AngularFileUploaderService.ɵprov = ɵɵdefineInjectable({ factory: function AngularFileUploaderService_Factory() { return new AngularFileUploaderService(); }, token: AngularFileUploaderService, providedIn: "root" });
    AngularFileUploaderService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [])
    ], AngularFileUploaderService);
    return AngularFileUploaderService;
}());

var AngularFileUploaderComponent = /** @class */ (function () {
    function AngularFileUploaderComponent() {
        this.resetUpload = false;
        this.ApiResponse = new EventEmitter();
        this.everythingDone = new EventEmitter();
        this.formatsAllowedList = null;
        this.reg = /(?:\.([^.]+))?$/;
        this.selectedFiles = [];
        this.notAllowedList = [];
        this.Caption = [];
        this.singleFile = true;
        this.progressBarShow = false;
        this.uploadBtn = false;
        this.uploadMsg = false;
        this.afterUpload = false;
        this.uploadClick = true;
        this.currentUploads = [];
        this.idDate = +new Date();
    }
    AngularFileUploaderComponent.prototype.ngOnChanges = function (changes) {
        if (changes.config && this.config) {
            this.theme = this.config.theme || '';
            this.id =
                this.config.id ||
                    parseInt((this.idDate / 10000).toString().split('.')[1], 10) +
                        Math.floor(Math.random() * 20) * 10000;
            this.hideProgressBar = this.config.hideProgressBar || false;
            this.hideResetBtn = this.config.hideResetBtn || false;
            this.hideSelectBtn = this.config.hideSelectBtn || false;
            this.maxSize = this.config.maxSize || 20;
            this.limitSelection = this.config.limitSelection || -1;
            this.uploadAPI = this.config.uploadAPI.url;
            this.method = this.config.uploadAPI.method || 'POST';
            this.formatsAllowed =
                this.config.formatsAllowed || '.jpg,.png,.gif,.jpeg';
            this.formatsAllowedList = null;
            this.multiple = this.config.multiple || false;
            this.headers = this.config.uploadAPI.headers || {};
            this.oneFilePerRequest = !!this.config.oneFilePerRequest;
            var defaultReplaceTextsValues = {
                selectFileBtn: this.multiple ? 'Select Files' : 'Select File',
                resetBtn: 'Reset',
                uploadBtn: 'Upload',
                dragNDropBox: 'Drag N Drop',
                attachPinBtn: this.multiple ? 'Attach Files...' : 'Attach File...',
                afterUploadMsg_success: 'Successfully Uploaded !',
                afterUploadMsg_error: 'Upload Failed !',
            };
            if (this.config.replaceTexts) {
                this.replaceTexts = __assign(__assign({}, defaultReplaceTextsValues), this.config.replaceTexts);
            }
            else {
                this.replaceTexts = __assign({}, defaultReplaceTextsValues);
            }
        }
        if (changes.resetUpload) {
            if (changes.resetUpload.currentValue === true) {
                this.resetFileUpload();
            }
        }
    };
    AngularFileUploaderComponent.prototype.ngOnInit = function () {
    };
    AngularFileUploaderComponent.prototype.resetFileUpload = function () {
        this.selectedFiles = [];
        this.Caption = [];
        this.notAllowedList = [];
        this.uploadMsg = false;
        this.uploadBtn = false;
    };
    AngularFileUploaderComponent.prototype.onChange = function (event) {
        this.notAllowedList = [];
        if (this.afterUpload || !this.multiple) {
            this.selectedFiles = [];
            this.Caption = [];
            this.afterUpload = false;
        }
        if (this.formatsAllowedList === null) {
            this.formatsAllowedList = this.formatsAllowed.split('.').map(function (x) { return x.split(',')[0].trim().toLowerCase(); });
        }
        var fileList;
        if (event.type === 'drop') {
            fileList = event.dataTransfer.files;
        }
        else {
            fileList = event.target.files || event.srcElement.files;
        }
        var _loop_1 = function (i) {
            var currentFileExt = this_1.reg.exec(fileList[i].name)[1];
            var currentFileExtLower = currentFileExt.toLowerCase();
            var frmtAllowed = this_1.formatsAllowedList.some(function (x) { return x === currentFileExtLower; });
            if (frmtAllowed) {
                if (this_1.limitSelection > 0 && this_1.selectedFiles.length >= this_1.limitSelection) {
                    this_1.notAllowedList.push({
                        fileName: fileList[i].name,
                        fileSize: this_1.convertSize(fileList[i].size),
                        errorMsg: "Number of file(s) allowed exceeded.",
                    });
                }
                else if (fileList[i].size > this_1.maxSize * 1024000) {
                    this_1.notAllowedList.push({
                        fileName: fileList[i].name,
                        fileSize: this_1.convertSize(fileList[i].size),
                        errorMsg: 'Invalid size',
                    });
                }
                else {
                    this_1.selectedFiles.push(fileList[i]);
                }
            }
            else {
                this_1.notAllowedList.push({
                    fileName: fileList[i].name,
                    fileSize: this_1.convertSize(fileList[i].size),
                    errorMsg: 'Invalid format',
                });
            }
        };
        var this_1 = this;
        for (var i = 0; i < fileList.length; i++) {
            _loop_1(i);
        }
        if (this.selectedFiles.length !== 0) {
            this.uploadBtn = true;
            if (this.theme === 'attachPin') {
                this.uploadFiles();
            }
        }
        else {
            this.uploadBtn = false;
        }
        this.uploadMsg = false;
        this.uploadClick = true;
        this.percentComplete = 0;
        event.target.value = null;
    };
    AngularFileUploaderComponent.prototype.uploadFiles = function () {
        var _this = this;
        this.progressBarShow = true;
        this.uploadClick = false;
        this.notAllowedList = [];
        var isError = false;
        this.singleFile = this.selectedFiles.length <= 1;
        this.currentUploads = [];
        if (this.oneFilePerRequest && !this.singleFile) {
            this.selectedFiles.forEach(function (selectedFile, inx) {
                var xhr = new XMLHttpRequest();
                var formData = new FormData();
                // Add data to be sent in this request
                formData.append(_this.Caption[inx] || 'file' + inx, _this.selectedFiles[inx]);
                _this.currentUploads.push({ xhr: xhr, formData: formData, inxs: [inx] });
            });
        }
        else {
            var xhr = new XMLHttpRequest();
            var formData_1 = new FormData();
            // Add data to be sent in this request
            this.selectedFiles.forEach(function (selectedFile, inx) {
                formData_1.append(_this.Caption[inx] || 'file' + inx, _this.selectedFiles[inx]);
            });
            this.currentUploads.push({ xhr: xhr, formData: formData_1, inxs: this.selectedFiles.map(function (selectedFile, inx) { return inx; }) });
        }
        var totalUploads = this.currentUploads.length;
        this.currentUploads.forEach(function (upload, uploadInx) {
            var e_1, _a;
            var xhr = upload.xhr;
            xhr.onreadystatechange = function (evnt) {
                if (xhr.readyState === 4) {
                    if (xhr.status !== 200 && xhr.status !== 201) {
                        isError = true;
                        _this.progressBarShow = false;
                        _this.uploadBtn = false;
                        _this.uploadMsg = true;
                        _this.afterUpload = true;
                        _this.uploadMsgText = _this.replaceTexts.afterUploadMsg_error;
                        _this.uploadMsgClass = 'text-danger lead';
                    }
                    _this.ApiResponse.emit(xhr);
                    if (uploadInx + 1 === totalUploads) {
                        _this.everythingDone.emit(_this.currentUploads);
                    }
                }
            };
            xhr.upload.onprogress = function (evnt) {
                _this.uploadBtn = false; // button should be disabled by process uploading
                if (evnt.lengthComputable) {
                    var currentDone = (evnt.loaded / evnt.total);
                    _this.percentComplete = Math.round((uploadInx + currentDone) * 100 / totalUploads);
                }
            };
            xhr.onload = function (evnt) {
                _this.progressBarShow = false;
                _this.uploadBtn = false;
                _this.uploadMsg = true;
                _this.afterUpload = true;
                if (!isError) {
                    if (uploadInx + 1 === totalUploads) {
                        _this.uploadMsgText = _this.replaceTexts.afterUploadMsg_success;
                        _this.uploadMsgClass = 'text-success lead';
                    }
                    else {
                        var nextUpload = _this.currentUploads[uploadInx + 1];
                        nextUpload.xhr.send(nextUpload.formData);
                    }
                    _this.percentComplete = Math.round((uploadInx + 1) * 100 / totalUploads);
                }
            };
            xhr.open(_this.method, _this.uploadAPI, true);
            try {
                for (var _b = __values(Object.keys(_this.headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    // Object.keys will give an Array of keys
                    console.log("Adding Header: " + key);
                    console.log("Adding Header value: " + _this.headers[key]);
                    xhr.setRequestHeader(key, _this.headers[key]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        var firstUpload = this.currentUploads[0];
        firstUpload.xhr.send(firstUpload.formData);
    };
    AngularFileUploaderComponent.prototype.removeFile = function (i, sf_na) {
        if (sf_na === 'sf') {
            this.selectedFiles.splice(i, 1);
            this.Caption.splice(i, 1);
        }
        else {
            this.notAllowedList.splice(i, 1);
        }
        if (this.selectedFiles.length === 0) {
            this.uploadBtn = false;
        }
    };
    AngularFileUploaderComponent.prototype.convertSize = function (fileSize) {
        return fileSize < 1024000
            ? (fileSize / 1024).toFixed(2) + ' KB'
            : (fileSize / 1024000).toFixed(2) + ' MB';
    };
    AngularFileUploaderComponent.prototype.attachpinOnclick = function () {
        var element = document.getElementById('sel' + this.id);
        if (element !== null) {
            element.click();
        }
    };
    AngularFileUploaderComponent.prototype.drop = function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.onChange(event);
    };
    AngularFileUploaderComponent.prototype.allowDrop = function (event) {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], AngularFileUploaderComponent.prototype, "config", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], AngularFileUploaderComponent.prototype, "resetUpload", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], AngularFileUploaderComponent.prototype, "ApiResponse", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], AngularFileUploaderComponent.prototype, "everythingDone", void 0);
    AngularFileUploaderComponent = __decorate([
        Component({
            selector: 'angular-file-uploader',
            template: "<div class=\"container\" *ngIf=\"(theme !== 'attachPin')\" id=\"default\">\r\n\r\n    <!-- Drag n Drop theme Starts -->\r\n    <div *ngIf=\"theme == 'dragNDrop'\" id=\"dragNDrop\"\r\n        [ngClass]=\"(hideSelectBtn && hideResetBtn) ? null : 'dragNDropBtmPad'\" class=\"dragNDrop\">\r\n        <div style=\"position:relative;\">\r\n            <div id=\"div1\" class=\"div1 afu-dragndrop-box\" (drop)=\"drop($event)\" (dragover)=\"allowDrop($event)\">\r\n                <p class=\"afu-dragndrop-text\">{{replaceTexts?.dragNDropBox}}</p>\r\n            </div>\r\n            <!-- <span class='label label-info' id=\"upload-file-info{{id}}\">{{selectedFiles[0]?.name}}</span> -->\r\n        </div>\r\n    </div>\r\n    <!-- Drag n Drop theme Ends -->\r\n\r\n    <label for=\"sel{{id}}\" class=\"btn btn-primary btn-sm afu-select-btn\"\r\n        *ngIf=\"!hideSelectBtn\">{{replaceTexts?.selectFileBtn}}</label>\r\n    <input type=\"file\" id=\"sel{{id}}\" style=\"display: none\" *ngIf=\"!hideSelectBtn\" (change)=\"onChange($event)\"\r\n        title=\"Select file\" name=\"files[]\" [accept]=formatsAllowed [attr.multiple]=\"multiple ? '' : null\" />\r\n    <button class=\"btn btn-info btn-sm resetBtn afu-reset-btn\" (click)=\"resetFileUpload()\"\r\n        *ngIf=\"!hideResetBtn\">{{replaceTexts?.resetBtn}}</button>\r\n    <!-- <br *ngIf=\"!hideSelectBtn\"> -->\r\n    <p class=\"constraints-info afu-constraints-info\">({{formatsAllowed}}) Size limit- {{(convertSize(maxSize\r\n        *1024000))}}</p>\r\n    <!--Selected file list-->\r\n    <div class=\"row afu-valid-file\" *ngFor=\"let sf of selectedFiles;let i=index\">\r\n        <p class=\"col-xs-3 textOverflow\"><span class=\"text-primary\">{{sf.name}}</span></p>\r\n        <p class=\"col-xs-3 padMarg sizeC\"><strong>({{convertSize(sf.size)}})</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>\r\n        <!--  <input class=\"col-xs-3 progress caption\"  type=\"text\"  placeholder=\"Caption..\"  [(ngModel)]=\"Caption[i]\"  *ngIf=\"uploadClick\"/> -->\r\n        <!-- <div class=\"progress col-xs-4 padMarg afu-progress-bar\"\r\n            *ngIf=\"singleFile && progressBarShow && !hideProgressBar\">\r\n            <span class=\"progress-bar progress-bar-success\" role=\"progressbar\"\r\n                [ngStyle]=\"{'width':percentComplete+'%'}\">{{percentComplete}}%</span>\r\n        </div> -->\r\n        <a class=\"col-xs-1\" role=\"button\" (click)=\"removeFile(i,'sf')\" *ngIf=\"uploadClick\"><i\r\n                class=\"fa fa-times\"></i></a>\r\n    </div>\r\n    <!--Invalid file list-->\r\n    <div class=\"row text-danger afu-invalid-file\" *ngFor=\"let na of notAllowedList;let j=index\">\r\n        <p class=\"col-xs-3 textOverflow\"><span>{{na['fileName']}}</span></p>\r\n        <p class=\"col-xs-3 padMarg sizeC\"><strong>({{na['fileSize']}})</strong></p>\r\n        <p class=\"col-xs-3 \">{{na['errorMsg']}}</p>\r\n        <a class=\"col-xs-1 delFileIcon\" role=\"button\" (click)=\"removeFile(j,'na')\" *ngIf=\"uploadClick\">&nbsp;<i\r\n                class=\"fa fa-times\"></i></a>\r\n    </div>\r\n\r\n    <p *ngIf=\"uploadMsg\" class=\"{{uploadMsgClass}} + afu-upload-status\">{{uploadMsgText}}\r\n    <p>\r\n    <div *ngIf=\"progressBarShow && !hideProgressBar\">\r\n        <div class=\"progress col-xs-4 padMarg afu-progress-bar\">\r\n            <span class=\"progress-bar progress-bar-success\" role=\"progressbar\"\r\n                [ngStyle]=\"{'width':percentComplete+'%'}\">{{percentComplete}}%</span>\r\n        </div>\r\n        <br>\r\n        <br>\r\n    </div>\r\n    <button class=\"btn btn-success afu-upload-btn\" type=\"button\" (click)=\"uploadFiles()\"\r\n        [disabled]=!uploadBtn>{{replaceTexts?.uploadBtn}}</button>\r\n    <br>\r\n</div>\r\n\r\n<!--/////////////////////////// ATTACH PIN THEME  //////////////////////////////////////////////////////////-->\r\n<div *ngIf=\"theme == 'attachPin'\" id=\"attachPin\">\r\n    <div style=\"position:relative;padding-left:6px\">\r\n        <a class='btn up_btn afu-attach-pin' (click)=\"attachpinOnclick()\">\r\n            {{replaceTexts?.attachPinBtn}}\r\n            <i class=\"fa fa-paperclip\" aria-hidden=\"true\"></i>\r\n            <!-- <p style=\"margin-top:10px\">({{formatsAllowed}}) Size limit- {{(convertSize(maxSize * 1024000))}}</p> -->\r\n            <input type=\"file\" id=\"sel{{id}}\" (change)=\"onChange($event)\" style=\"display: none\" title=\"Select file\"\r\n                name=\"files[]\" [accept]=formatsAllowed [attr.multiple]=\"multiple ? '' : null\" />\r\n            <br>\r\n        </a>\r\n        &nbsp;\r\n        <span class='label label-info' id=\"upload-file-info{{id}}\">{{selectedFiles[0]?.name}}</span>\r\n    </div>\r\n</div>\r\n\r\n<!--/////////////////////////// DRAG N DROP THEME  //////////////////////////////////////////////////////////-->\r\n<!-- <div *ngIf=\"theme == 'dragNDrop'\" id=\"dragNDrop\">\r\n  <div style=\"position:relative;padding-left:6px\">\r\n    <div id=\"div1\" (drop)=\"drop($event)\" (dragover)=\"allowDrop($event)\">\r\n      <p>Drag N Drop</p>\r\n    </div>\r\n    <span class='label label-info' id=\"upload-file-info{{id}}\">{{selectedFiles[0]?.name}}</span>\r\n  </div>\r\n</div> -->",
            styles: [".constraints-info{margin-top:10px;font-style:italic;margin-right:.5em}.padMarg{padding:0;margin-bottom:0}.caption{margin-right:5px}.textOverflow{white-space:nowrap;padding-right:0;overflow:hidden;text-overflow:ellipsis}.up_btn{color:#000;background-color:transparent;border:2px solid #5c5b5b;border-radius:22px}.delFileIcon{text-decoration:none;color:#ce0909}.dragNDrop .div1{display:border-box;border:2px dashed #5c5b5b;height:6rem;width:20rem}.dragNDrop .div1>p{text-align:center;font-weight:700;color:#5c5b5b;margin-top:1.4em}.dragNDropBtmPad{padding-bottom:2rem}@media screen and (max-width:620px){.caption{padding:0}}@media screen and (max-width:510px){.sizeC{width:25%}}@media screen and (max-width:260px){.caption,.sizeC{font-size:10px}}.resetBtn{margin-left:3px}"]
        }),
        __metadata("design:paramtypes", [])
    ], AngularFileUploaderComponent);
    return AngularFileUploaderComponent;
}());

var AngularFileUploaderModule = /** @class */ (function () {
    function AngularFileUploaderModule() {
    }
    AngularFileUploaderModule = __decorate([
        NgModule({
            imports: [
                CommonModule
            ],
            declarations: [AngularFileUploaderComponent],
            exports: [AngularFileUploaderComponent]
        })
    ], AngularFileUploaderModule);
    return AngularFileUploaderModule;
}());

/*
 * Public API Surface of angular-file-uploader
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularFileUploaderComponent, AngularFileUploaderModule, AngularFileUploaderService };
//# sourceMappingURL=angular-file-uploader.js.map
